export default "__VITE_ASSET__LHnRcrQn__"